// src/App.js
import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';

import LoginPage from './pages/LoginPage';
import DashboardPage from './pages/DashboardPage';
import ProspectosPage from './pages/ProspectosPage';
import PrivateRoute from './components/PrivateRoute';
import AdminRoute from './components/AdminRoute';
import AdminModeratorRoute from './components/AdminModeratorRoute';
import ForgotPasswordPage from './pages/ForgotPasswordPage';
import VerifyResetTokenPage from './pages/VerifyResetTokenPage';
import ChangePasswordPage from './pages/ChangePasswordPage';
import Sidebar from './components/Sidebar';
// TEMPORALMENTE COMENTADO - SOLO LOGIN Y DASHBOARD ACTIVOS
// import InteresadosPage from './pages/InteresadosPage.js';
// import EditarInteresadoPage from './pages/EditarInteresadoPage.js';
import EditarPerfilPage from './pages/EditarPerfilPage';
import EditarProspectoPage from './pages/EditarProspectoPage';
// import Promociones from './pages/Promociones.js';
import AlumnosPage from './pages/AlumnosPage.js';
import EditarAlumnoPage from './pages/EditarAlumnoPage.js';
// import BajasPage from './pages/BajasPage.js';
// import EditarBajasPage from './pages/EditarBajasPage.js';
// import RestaurarProspectoPage from './pages/RestaurarProspectoPage.js';
// import RegistrarBajaPage from './pages/RegistrarBajaPage.js';
import CursosPage from './pages/CursosPage.js';
import EditarCursoPage from './pages/EditarCursoPage.js';
// import EditarRedSocialPage from './pages/EditarRedSocialPage.js';
// import RedesSocialesPage from './pages/RedesSocialesPage.js';
import UsuariosPage from './pages/UsuariosPage.js';
import EditarUsuarioPage from './pages/EditarUsuarioPage.js';
import HistorialCambiosPage from './pages/HistorialCambiosPage.js';

import SocketListener from './context/AccountSocket.js';


function App() {
  const currentUserId = localStorage.getItem('userId');




  return (
    <Router>
      <SocketListener currentUserId={currentUserId} />
      <Routes>
        <Route path="/login" element={<LoginPage />} />
        <Route path="/" element={<LoginPage />} />

    
        <Route 
          path="/dashboard" 
          element={
            <PrivateRoute>
              <DashboardPage />
            </PrivateRoute>
          } 
        />
         <Route 
          path="/prospectos" 
          element={
            <PrivateRoute>
              <ProspectosPage />
            </PrivateRoute>
          } 
        />
        <Route
        path="/prospectos/agregar"
        element={
          <PrivateRoute>
              <AdminModeratorRoute>
          <EditarProspectoPage />
          </AdminModeratorRoute>
          </PrivateRoute>
  }
/>
<Route
  path="/prospectos/editar/:id"
  element={
    <PrivateRoute>
       <AdminModeratorRoute>
      <EditarProspectoPage />
      </AdminModeratorRoute>
    </PrivateRoute>
  }
/>
         {/* TEMPORALMENTE COMENTADO - SOLO LOGIN Y DASHBOARD ACTIVOS
        <Route 
          path="/promociones" 
          element={
            <PrivateRoute>
              <Promociones />
            </PrivateRoute>
          } 
        />
        */}

        <Route 
          path="/alumnos" 
          element={
            <PrivateRoute>
              <AlumnosPage />
            </PrivateRoute>
          } 
        />
        <Route
          path="/alumnos/agregar"
          element={
            <PrivateRoute>
              <AdminModeratorRoute>
                <EditarAlumnoPage />
              </AdminModeratorRoute>
            </PrivateRoute>
          }
        />
        <Route
          path="/alumnos/editar/:id"
          element={
            <PrivateRoute>
              <AdminModeratorRoute>
                <EditarAlumnoPage />
              </AdminModeratorRoute>
            </PrivateRoute>
          }
        />

        <Route 
          path="/cursos" 
          element={
            <PrivateRoute>
              <CursosPage />
            </PrivateRoute>
          } 
        />
        <Route
          path="/cursos/agregar"
          element={
            <PrivateRoute>
              <AdminModeratorRoute>
                <EditarCursoPage />
              </AdminModeratorRoute>
            </PrivateRoute>
          }
        />
        <Route
          path="/cursos/editar/:id"
          element={
            <PrivateRoute>
              <AdminModeratorRoute>
                <EditarCursoPage />
              </AdminModeratorRoute>
            </PrivateRoute>
          }
        />

        <Route 
          path="/cuentas" 
          element={
            <PrivateRoute>
              <AdminRoute>
                <UsuariosPage />
              </AdminRoute>
            </PrivateRoute>
          } 
        />
        <Route
          path="/cuentas/agregar"
          element={
            <PrivateRoute>
              <AdminRoute>
                <EditarUsuarioPage />
              </AdminRoute>
            </PrivateRoute>
          }
        />
        <Route
          path="/cuentas/editar/:id"
          element={
            <PrivateRoute>
              <AdminRoute>
                <EditarUsuarioPage />
              </AdminRoute>
            </PrivateRoute>
          }
        />

        <Route 
          path="/editar-perfil" 
          element={
            <PrivateRoute>
                <EditarPerfilPage />
              
            </PrivateRoute>
          }
        />

        {/* RUTAS COMENTADAS - NO SE USAN EN EL PROYECTO
        <Route
          path="/bajas"
          element={
            <PrivateRoute>
              <BajasPage />
            </PrivateRoute>
          }
        />
        <Route
          path="/bajas/agregar"
          element={
            <PrivateRoute>
              <EditarBajasPage />
            </PrivateRoute>
          }
        />
        <Route
          path="/bajas/editar/:id"
          element={
            <PrivateRoute>
              <EditarBajasPage />
            </PrivateRoute>
          }
        />

        <Route
          path="/redes"
          element={
            <PrivateRoute>
              <RedesSocialesPage />
            </PrivateRoute>
          }
        />
        */}

        <Route
          path="/historial"
          element={
            <PrivateRoute>
              <AdminRoute>
                <HistorialCambiosPage />
              </AdminRoute>
            </PrivateRoute>
          }
        />

      <Route path="/forgot-password" element={<ForgotPasswordPage />} />

 
       <Route path="/verify-token" element={<VerifyResetTokenPage />} />

      
        <Route path="/change-password" element={<ChangePasswordPage />} />


        
        <Route path="*" element={<h2>404 - Página no encontrada</h2>} />


      </Routes>
    </Router>
  );
}

export default App;
